var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dialog-mask",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.handleClickOutside.apply(null, arguments)}}},[_c('div',{staticClass:"dialog-content"},[_vm._t("header"),_vm._t("body"),_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }